import asyncComponent from '../helpers/AsyncFunc';

const routes = [
  {
    path: 'githubSearch',
    component: asyncComponent(() => import('./containers/GithubSearch'))
  },
  {
    path: 'blank_page',
    component: asyncComponent(() => import('./containers/blankPage'))
  },
  {
    path: 'shared_spaces',
    component: asyncComponent(() => import('../containers/SharedSpaces'))
  },
  {
    path: 'shared_spaces/new',
    component: asyncComponent(() => import('../containers/SharedSpaces/new.js'))
  }
];
export default routes;
